export namespace OdConsts {
  export const dataDownloadErrorLoadingFilesList = 'Error occurred while loading files';
  export const miDataDownloadFileName = 'origin-destination.zip';
  export const bigDownloadDataSize = 1000000000;
  export const sampleClientName = 'sample';
}
